import React from 'react';
import './businesssupport.scss';

const BusinessSupport = () => {
  const categories = [
    'Brands',
    'E-Commerce',
    'Marketing Agencies',
    'Local Business',
    'Freelancers',
    'Affiliates',
    'Dropshippers',
    'Influencers',
  ];

  return (
    <div className="business-support">
      <h1 className="business-support__title">Comprehensive Support for Diverse Businesses</h1>
      <p className="business-support__subtitle">
        Tailored to fit businesses of every type and size, our expert teams offer bespoke solutions, empowering growth and success in the digital realm.
      </p>
      <div className="business-support__categories" >
        {categories.map((category, index) => (
          <div key={index} className="business-support__category"  >
            {category}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessSupport;
